import React from 'react';
import CookieIcon from '@mui/icons-material/Cookie';
import LegalPage from '../../components/Legal/LegalPage';
import CookieManager from './CookieManager';

/** Çerez Politikası — tercih paneli içerikteki "cookieManager" yuvasına yerleşir. */
const Cookies = () => (
  <LegalPage ns="cookies" docKey="cookies" icon={<CookieIcon />} slots={{ cookieManager: <CookieManager /> }} />
);

export default Cookies;
